"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locale = void 0;
let currentLocale = 'es';
const locale = {
    setLocale(newLocale) {
        currentLocale = newLocale;
    },
    getLocale() {
        return currentLocale;
    },
};
exports.locale = locale;
Object.freeze(locale);
//# sourceMappingURL=locale.js.map